import styled from 'styled-components'

export const ProgressWrap = styled.div`
  display: flex;
  width: 112px;
  height: 8px;
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.1);
`

interface FillProps {
  progress: number
}

export const Fill = styled.div<FillProps>`
  display: flex;
  height: 8px;
  border-radius: 4px;
  background-image: linear-gradient(225deg, #ff8e3a, #f45d19 -20%);
  width: ${({ progress }) => progress}%;
  transition: width 0.5s;
`
